const Roles = {
  ANALYTICS_COMPLIANCE: 'analytics_compliance',
  ANALYTICS_COMPLIANCE_EXEC: 'analytics_compliance_exec',
  COMPLIANCE_DASHBOARD: 'compliance_dashboard',
  'ANALYTICS_PRODUCTS': 'analytics_products',
  'ANALYTICS_DASHBOARD': 'analytics_dashboard',
  'ANALYTICS_SALES_LEADERS': 'analytics_sales_leaders',
  'ANALYTICS_ONLINE_PERFORMANCE': 'analytics_online_performance',
  ANALYTICS_TRAFFIC: 'analytics_traffic_summary',
  'USER_MANAGER': 'user_manager',
  'BANK_MANAGER': 'bank_manager',
  'GUIDE_MANAGER': 'guide_manager',
  'PRODUCT_MANAGER': 'product_manager',
  'PUBLISHING': 'publishing',
  CLIENT_MANAGER: 'client_manager'
};

export default Roles;



// WEBPACK FOOTER //
// ./src/constants/Roles.js